import { createFileRoute } from '@tanstack/react-router';
import { TwContainer } from '~/lib/TwContainer';
import { Anchor, Card, Divider, Flex, Stack, Text, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { ContactForm } from '~/components/ContactForm';

export const Route = createFileRoute('/contact/')({
	component: RouteComponent,
});

function RouteComponent() {
	const isMobile = useMediaQuery('(max-width: 768px)');
	return (
		<section
			className="bg-dark relative"
			style={{ transition: 'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s' }}>
			<div className="background-overlay"></div>
			<TwContainer className="py-24 md:px-8 px-4 z-10 ">
				<Title className="text-6xl font-medium font-saira text-primary text-center">Contact Us</Title>
				<Title className="text-3xl font-semibold font-beVietnamPro text-white text-center">Don't hesitate to contact us for more information</Title>
				<Card className={'bg-secondary my-16'}>
					<Flex className={'flex md:flex-row flex-col md:p-16 justify-around py-16'}>
						<Stack className={'my-auto flex-grow mx-auto'}>
							<Stack gap={0}>
								<Title className={'my-auto font-saira text-gray-300 md:text-3xl text-2xl max-w-sm'}>Address</Title>
								<Text className={'text-white'}>
									13790 Nw 4 St, ste 111,
									<br />
									Sunrise, FL 33325
								</Text>
							</Stack>
							<Stack gap={0}>
								<Title className={'my-auto font-saira text-gray-300 md:text-3xl text-2xl max-w-sm'}>Phone</Title>
								<Anchor
									className={'text-white'}
									href={'tel:+1 (954) 250-2008'}>
									+1 (954) 250-2008
								</Anchor>
							</Stack>
							<Stack gap={0}>
								<Title className={'my-auto font-saira text-gray-300 md:mt-6 mt-2 md:text-3xl text-2xl max-w-sm'}>Email Us</Title>
								<Anchor
									className={'text-white'}
									href={'mailto:info@champteks.com'}>
									info@champteks.com
								</Anchor>
							</Stack>
						</Stack>
						<div className={'md:px-12 my-12'}>
							<Divider
								orientation={isMobile ? 'vertical' : 'horizontal'}
								className={'md:h-full w-full md:w-0 h-0 border-primary border-2 mx-0'}
							/>
						</div>
						<ContactForm
							className={'grow flex flex-col gap-6'}
							textInputProps={{
								labelProps: { className: 'text-gray-300' },
							}}
						/>
					</Flex>
				</Card>
			</TwContainer>
		</section>
	);
}
